<template>
  <div class="details-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="header-content">
        <!-- Calendar Leaf Date Display -->
        <div class="date-display">
          <div class="calendar-leaf">
            <span class="calendar-day">{{ formattedDate.day }}</span>
            <span class="calendar-month">{{ formattedDate.month }}</span>
            <span class="calendar-year">{{ formattedDate.year }}</span>
          </div>
        </div>
        <div class="header-info">
          <h1>Dettagli Booking</h1>
          <div class="flex justify-center w-full">
  <span class="service-type">
    {{ booking_info.title_prenotazione }}
  </span>
</div>
        </div>
      </div>

      <!-- Status Alert -->
      <div v-if="type == 5 || type == 7" class="status-alert">
        <el-icon class="alert-icon pulse">
          <BellFilled />
        </el-icon>
        <span v-if="type == 5" class="alert-text">
          Il driver ha in dotazione la vostra vettura
        </span>
        <span v-if="type == 7" class="alert-text">
          Il driver ritira l'auto di cortesia
        </span>
      </div>
    </div>

    <!-- Main Content Grid -->
    <div class="content-grid">
      <!-- Customer Info Card -->
      <div class="info-card">
        <div class="card-header">
          <el-icon class="card-icon"><User /></el-icon>
          <h3>Informazioni Cliente</h3>
        </div>
        <div class="card-body">
          <div class="info-row">
            <span class="info-label">Nome</span>
            <span class="info-value">{{ booking_info.customer }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Telefono</span>
            <span class="info-value">{{ booking_info.customer_number }}</span>
          </div>
        </div>
      </div>

      <!-- Vehicle Info Card (conditional) -->
      <div v-if="type == 1 || type == 4 || type == 6 || type == 7" class="info-card">
        <div class="card-header">
          <el-icon class="card-icon"><Van /></el-icon>
          <h3>Veicolo</h3>
        </div>
        <div class="card-body">
          <div class="info-row">
            <span class="info-label">Auto</span>
            <span class="info-value">{{ booking_info.auto }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Targa</span>
            <span class="license-plate">{{ booking_info.targa }}</span>
          </div>
        </div>
      </div>

      <!-- Partner Location Card -->
      <div class="info-card">
        <div class="card-header">
          <el-icon class="card-icon"><OfficeBuilding /></el-icon>
          <h3>Sede Partner</h3>
        </div>
        <div class="card-body">
          <div class="info-row full-width">
            <span class="info-label">Indirizzo</span>
            <span class="info-value">{{ booking_info.partner_point }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Booking Details Section -->
    <div class="section">
      <h2 class="section-title">
        <el-icon><LocationInformation /></el-icon>
        Dettagli Percorso
      </h2>

      <!-- PICKUP Booking Details -->
      <div v-if="type == 7 || type == 1" class="route-cards">
        <div v-if="is_gone" class="route-card gone">
          <div class="route-header">
            <span class="route-label">Andata</span>
            <span class="km-badge">{{ booking_info.simba_km_range_gone }} km</span>
          </div>
          <div class="route-content">
            <div class="location-item">
              <el-icon class="location-icon start"><Location /></el-icon>
              <div class="location-details">
                <span class="location-type">Punto di prelievo</span>
                <span class="location-address">{{ booking_info.origin_point_gone }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="is_return" class="route-card return">
          <div class="route-header">
            <span class="route-label">Ritorno</span>
            <span class="km-badge">{{ booking_info.simba_km_range_return }} km</span>
          </div>
          <div class="route-content">
            <div class="location-item">
              <el-icon class="location-icon end"><Location /></el-icon>
              <div class="location-details">
                <span class="location-type">Punto di consegna</span>
                <span class="location-address">{{ booking_info.destination_point_return }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ESCORT Booking Details -->
      <div v-if="type == 5 || type == 6 || type == 4 || type == 2" class="route-cards">
        <div v-if="is_gone" class="route-card gone">
          <div class="route-header">
            <span class="route-label">Andata</span>
            <span class="km-badge">{{ booking_info.simba_km_range_gone }} km</span>
          </div>
          <div class="route-content">
            <div class="location-item">
              <el-icon class="location-icon end"><Location /></el-icon>
              <div class="location-details">
                <span class="location-type">Punto di consegna</span>
                <span class="location-address">{{ booking_info.destination_point_gone }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="is_return" class="route-card return">
          <div class="route-header">
            <span class="route-label">Ritorno</span>
            <span class="km-badge">{{ booking_info.simba_km_range_return }} km</span>
          </div>
          <div class="route-content">
            <div class="location-item">
              <el-icon class="location-icon start"><Location /></el-icon>
              <div class="location-details">
                <span class="location-type">Punto di prelievo</span>
                <span class="location-address">{{ booking_info.origin_point_return }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DELIVERY Booking Details -->
      <div v-if="type == 3" class="route-cards">
        <div class="route-card delivery">
          <div class="route-header">
            <span class="route-label">Consegna</span>
            <span class="km-badge">{{ booking_info.simba_km_range_gone }} km</span>
          </div>
          <div class="route-content">
            <div class="location-item">
              <el-icon class="location-icon start"><Location /></el-icon>
              <div class="location-details">
                <span class="location-type">Partenza</span>
                <span class="location-address">{{ booking_info.origin_point_gone }}</span>
              </div>
            </div>
            <div class="route-arrow">
              <el-icon><ArrowRight /></el-icon>
            </div>
            <div class="location-item">
              <el-icon class="location-icon end"><Location /></el-icon>
              <div class="location-details">
                <span class="location-type">Destinazione</span>
                <span class="location-address">{{ booking_info.destination_point_gone }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Driver Section -->
    <div class="section">
      <h2 class="section-title">
        <el-icon><User /></el-icon>
        Informazioni Driver
      </h2>

      <div class="driver-cards">
        <!-- Driver Andata -->
        <div v-if="is_gone" class="driver-card">
          <div class="driver-header">
            <span class="driver-type">{{ type == 3 ? 'Driver' : 'Driver Andata' }}</span>
          </div>
          <div class="driver-content">
            <div class="driver-avatar">
              <el-icon><User /></el-icon>
            </div>
            <div class="driver-info">
              <span class="driver-name">{{ booking_info.driver_andata }}</span>
              <span class="driver-phone">
                <el-icon><Phone /></el-icon>
                {{ booking_info.telephone_gone_driver }}
              </span>
            </div>
          </div>
        </div>

        <!-- Driver Ritorno -->
        <div v-if="is_return" class="driver-card">
          <div class="driver-header">
            <span class="driver-type">Driver Ritorno</span>
          </div>
          <div class="driver-content">
            <div class="driver-avatar">
              <el-icon><User /></el-icon>
            </div>
            <div class="driver-info">
              <span class="driver-name">{{ booking_info.driver_ritorno }}</span>
              <span class="driver-phone">
                <el-icon><Phone /></el-icon>
                {{ booking_info.telephone_return_driver }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Car Description (Delivery only) -->
    <div v-if="type == 3" class="section">
      <h2 class="section-title">
        <el-icon><Van /></el-icon>
        Descrizione Auto
      </h2>
      <div class="info-card single">
        <div class="card-body">
          <p class="car-description">{{ booking_info.car_description }}</p>
        </div>
      </div>
    </div>

    <!-- Notes Section (Delivery only) -->
    <div v-if="type == 3 && noteVisibile" class="section">
      <h2 class="section-title">
        <el-icon><Document /></el-icon>
        Note
      </h2>
      <div class="info-card single">
        <div class="card-body">
          <p class="notes-text">{{ booking_info.note }}</p>
        </div>
      </div>
    </div>

    <!-- Tasks Section -->
    <div v-if="type == 1 || type == 4 || type == 7 || type == 6" class="section">
      <h2 class="section-title">
        <el-icon><List /></el-icon>
        Lavori da Svolgere
      </h2>

      <div class="tasks-container">
        <el-collapse v-model="activeName" accordion class="tasks-collapse">
          <el-collapse-item name="1">
            <template #title>
              <div class="collapse-header">
                <span>Dettagli dei lavori</span>
                <el-tag type="info" size="small">{{ booking_info.tasks?.length || 0 }} attività</el-tag>
              </div>
            </template>

            <div class="tasks-list">
              <div
                v-for="(task, counter_min) in booking_info.tasks"
                :key="counter_min"
                class="task-item"
              >
                <div class="task-content">
                  <div class="task-description">{{ task.description }}</div>
                  <div class="task-meta">
                    <span class="task-cost">{{ task.cost }} €</span>
                    <el-tag
                      v-if="task.pay && task.accepted"
                      type="success"
                      size="small"
                    >
                      Pagamento in app
                    </el-tag>
                    <el-tag
                      v-if="task.pay && !task.accepted"
                      type="warning"
                      size="small"
                    >
                      In attesa conferma
                    </el-tag>
                    <el-tag
                      v-if="!task.pay"
                      type="info"
                      size="small"
                    >
                      Pagamento NON in app
                    </el-tag>
                  </div>
                </div>
                <el-button
                  type="danger"
                  size="small"
                  @click="deleteTask(task.id)"
                  circle
                >
                  <el-icon><Delete /></el-icon>
                </el-button>
              </div>
            </div>

            <div class="tasks-total">
              <span>Costo Totale</span>
              <span class="total-amount">{{ booking_info.tot_cost }} €</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- Action Buttons -->
    <div v-if="showDeleteButton" class="actions-section">
      <el-button type="danger" size="large" @click="open">
        <el-icon><Delete /></el-icon>
        Elimina la prenotazione
      </el-button>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import bookingAPI from '../services/bookingAPI.js';
import { useRoute, useRouter } from 'vue-router';
import { reactive } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Delete } from '@element-plus/icons-vue';
const dayjs = require('dayjs');
require('dayjs/locale/it');

export default {
  name: 'HomePage',
  components: { Delete },
  setup() {
    //0: default, 1:pickup, 2:escort, 3:delivery, 4:escort+tagliando, 5:escort+auto partner, 6: escort+tagliando+auto partner, 7:pickup+ auto cortesia

    const router = useRouter();
    const type = ref(0);
    let condition1 = false;
    let condition2 = true;
    let noteVisibile = ref(false);
    const activeName = ref('1');
    const route = useRoute();
    const bookingId = route.params.id.split('-')[0];
    const tableData = ref([]);
    const booking_info = reactive({
      customer: '',
      date:"",
      customer_number: '',
      auto: '',
      targa: '',
      tasks: [],
      driver_andata: '',
      driver_ritorno: '',
      telephone_gone_driver: '',
      telephone_return_driver: '',
      title_prenotazione: '',
      title: 'Costo totale dei lavori',
      tot_cost: 0,
      state: '',
      simba_km_range_gone: 0,
      simba_km_range_return: 0,

      origin_point_gone: '',
      destination_point_gone: '',

      origin_point_return: '',
      destination_point_return: '',

      car_description: '',
      note: '',
      tot_fattura:0
    });

    let date_gone = ref('');
    let hour_gone = ref('');
    let date_return = ref('');
    let hour_return = ref('');

    let is_gone = ref(false);
    let is_return = ref(false);

    const loadBooking = async () => {
      try {
        const response = await bookingAPI.getBookingById(route.params.id);
        const booking = response.data;

        booking_info.date = dayjs(booking.data).format(
          'DD/MM/YYYY'
        );

        checkBookingDate( booking.data);

        booking_info.customer =
          booking.customer.name + ' ' + booking.customer.surname;
        booking_info.customer_number = booking.customer.telephone_number;
        booking_info.state = booking.state;

        if (booking.note != '') {
          const note = booking.note.split(',');
          if (note.length != 0) {
            booking_info.car_description =
              note[0] + ', ' + note[1] + ', ' + note[2] + ', ' + note[3];
            if (note.length == 5) {
              noteVisibile.value = true;
              booking_info.note = note[4].split(':')[1];
            }
          }
        }

        booking_info.partner_point =
          booking.headquarter.address +
          ' ' +
          booking.headquarter.street_number +
          ', ' +
          booking.headquarter.cap +
          ' ' +
          booking.headquarter.city +
          ' ' +
          booking.headquarter.province;

        if (booking.pickup_bookings && booking.pickup_bookings.length > 0) {
          booking_info.title_prenotazione = 'Pickup e Delivery';
          booking_info.auto = booking.car.marca + ', ' + booking.car.modello;
          booking_info.targa = booking.car.targa;
          booking_info.tasks = booking.tasks;

          booking.loaner == true ? (type.value = 7) : (type.value = 1);

          booking.tasks.forEach((task) => {
            booking_info.tot_cost = booking_info.tot_cost + task.cost;
          });

          for (let i = 0; i < booking.pickup_bookings.length; i++) {
            const currentBooking = booking.pickup_bookings[i];

            if (currentBooking.type_booking === 'gone') {

              date_gone.value = currentBooking.date_partner;
              hour_gone.value = dayjs(currentBooking.date_partner).format(
                'HH:mm'
              );
              is_gone.value = true;

              booking_info.simba_km_range_gone = currentBooking.simba_km_range;

              booking_info.origin_point_gone =
                currentBooking.point.address +
                ' ' +
                currentBooking.point.street_number +
                ', ' +
                currentBooking.point.cap +
                ' ' +
                currentBooking.point.city +
                ' ' +
                currentBooking.point.province;

              currentBooking.driver_pickup != null &&
              currentBooking.driver_pickup.is_alive == false
                ? (booking_info.driver_andata =
                    currentBooking.driver_pickup.name +
                    ' ' +
                    currentBooking.driver_pickup.surname)
                : 'Non assegnato';

              currentBooking.driver_pickup != null &&
              currentBooking.driver_pickup.is_alive == false
                ? (booking_info.telephone_gone_driver =
                    currentBooking.driver_pickup.telephone_number)
                : null;
            } else {
              date_return.value = currentBooking.date_partner;
              hour_return.value = dayjs(currentBooking.date_partner).format(
                'HH:mm'
              );
              is_return.value = true;

              booking_info.simba_km_range_return =
                currentBooking.simba_km_range;

              booking_info.destination_point_return =
                currentBooking.point.address +
                ' ' +
                currentBooking.point.street_number +
                ', ' +
                currentBooking.point.cap +
                ' ' +
                currentBooking.point.city +
                ' ' +
                currentBooking.point.province;

              currentBooking.driver_pickup != null &&
              currentBooking.driver_pickup.is_alive == false
                ? (booking_info.driver_ritorno =
                    currentBooking.driver_pickup.name +
                    ' ' +
                    currentBooking.driver_pickup.surname)
                : 'Non assegnato';

              currentBooking.driver_pickup != null &&
              currentBooking.driver_pickup.is_alive == false
                ? (booking_info.telephone_return_driver =
                    currentBooking.driver_pickup.telephone_number)
                : null;
            }
          }
        }

        if (booking.escort_bookings && booking.escort_bookings.length > 0) {
          for (let i = 0; i < booking.escort_bookings.length; i++) {
            const currentBooking = booking.escort_bookings[i];

            booking_info.title_prenotazione = 'Transfer';

            if (currentBooking.tasks == true && booking.loaner == true) {
              booking_info.auto =
                booking.car.marca + ', ' + booking.car.modello;
              booking_info.targa = booking.car.targa;
              type.value = 6;
            } else if (
              currentBooking.tasks == false &&
              booking.loaner == true
            ) {
              type.value = 5;
            } else if (
              currentBooking.tasks == true &&
              booking.loaner == false
            ) {
              booking_info.auto =
                booking.car.marca + ', ' + booking.car.modello;
              booking_info.targa = booking.car.targa;
              type.value = 4;
            } else {
              type.value = 2;
            }

            if (currentBooking.type_booking === 'gone') {
              date_gone.value = currentBooking.date_partner;
              hour_gone.value = dayjs(currentBooking.date_partner).format(
                'HH:mm'
              );
              is_gone.value = true;

              booking_info.simba_km_range_gone = currentBooking.simba_km_range;

              booking_info.origin_point_gone =
                currentBooking.point_origin_escort.address +
                ' ' +
                currentBooking.point_origin_escort.street_number +
                ', ' +
                currentBooking.point_origin_escort.cap +
                ' ' +
                currentBooking.point_origin_escort.city +
                ' ' +
                currentBooking.point_origin_escort.province;

              booking_info.destination_point_gone =
                currentBooking.point_destination_escort.address +
                ' ' +
                currentBooking.point_destination_escort.street_number +
                ', ' +
                currentBooking.point_destination_escort.cap +
                ' ' +
                currentBooking.point_destination_escort.city +
                ' ' +
                currentBooking.point_destination_escort.province;

              currentBooking.driver_escort != null &&
              currentBooking.driver_escort.is_alive == false
                ? (booking_info.driver_andata =
                    currentBooking.driver_escort.name +
                    ' ' +
                    currentBooking.driver_escort.surname)
                : 'Non assegnato';

              currentBooking.driver_escort != null &&
              currentBooking.driver_escort.is_alive == false
                ? (booking_info.telephone_gone_driver =
                    currentBooking.driver_escort.telephone_number)
                : null;
            } else {
              date_return.value = currentBooking.date_partner;
              hour_return.value = dayjs(currentBooking.date_partner).format(
                'HH:mm'
              );
              is_return.value = true;
              booking_info.simba_km_range_return =
                currentBooking.simba_km_range;

              booking_info.origin_point_return =
                currentBooking.point_origin_escort.address +
                ' ' +
                currentBooking.point_origin_escort.street_number +
                ', ' +
                currentBooking.point_origin_escort.cap +
                ' ' +
                currentBooking.point_origin_escort.city +
                ' ' +
                currentBooking.point_origin_escort.province;

              booking_info.destination_point_return =
                currentBooking.point_destination_escort.address +
                ' ' +
                currentBooking.point_destination_escort.street_number +
                ', ' +
                currentBooking.point_destination_escort.cap +
                ' ' +
                currentBooking.point_destination_escort.city +
                ' ' +
                currentBooking.point_destination_escort.province;

              currentBooking.driver_escort != null &&
              currentBooking.driver_escort.is_alive == false
                ? (booking_info.driver_ritorno =
                    currentBooking.driver_escort.name +
                    ' ' +
                    currentBooking.driver_escort.surname)
                : 'Non assegnato';

              currentBooking.driver_escort != null &&
              currentBooking.driver_escort.is_alive == false
                ? (booking_info.telephone_return_driver =
                    currentBooking.driver_escort.telephone_number)
                : null;
            }
          }
        }
        if (booking.delivery_bookings && booking.delivery_bookings.length > 0) {
          for (let i = 0; i < booking.delivery_bookings.length; i++) {
            booking_info.title_prenotazione = "Consegna un'auto";

            type.value = 3;
            const currentBooking = booking.delivery_bookings[i];

            if (currentBooking.type_booking === 'gone') {
              date_gone.value = currentBooking.date_point;
              hour_gone.value = dayjs(currentBooking.date_partner).format(
                'HH:mm'
              );
              is_gone.value = true;
              booking_info.simba_km_range_gone = currentBooking.simba_km_range;

              booking_info.origin_point_gone =
                currentBooking.point_origin_delivery.address +
                ' ' +
                currentBooking.point_origin_delivery.street_number +
                ', ' +
                currentBooking.point_origin_delivery.cap +
                ' ' +
                currentBooking.point_origin_delivery.city +
                ' ' +
                currentBooking.point_origin_delivery.province;

              booking_info.destination_point_gone =
                currentBooking.point_destination_delivery.address +
                ' ' +
                currentBooking.point_destination_delivery.street_number +
                ', ' +
                currentBooking.point_destination_delivery.cap +
                ' ' +
                currentBooking.point_destination_delivery.city +
                ' ' +
                currentBooking.point_destination_delivery.province;

              currentBooking.driver_delivery != null &&
              currentBooking.driver_delivery.is_alive == false
                ? (booking_info.driver_andata =
                    currentBooking.driver_delivery.name +
                    ' ' +
                    currentBooking.driver_delivery.surname)
                : 'Non assegnato';

              currentBooking.driver_delivery != null &&
              currentBooking.driver_delivery.is_alive == false
                ? (booking_info.telephone_gone_driver =
                    currentBooking.driver_delivery.telephone_number)
                : null;
            } else {
              date_return.value = currentBooking.date_point;
              hour_return.value = dayjs(currentBooking.date_partner).format(
                'HH:mm'
              );
              is_return.value = true;

              booking_info.simba_km_range_return =
                currentBooking.simba_km_range;
              booking_info.origin_point_return =
                currentBooking.point_origin_delivery.address +
                ' ' +
                currentBooking.point_origin_delivery.street_number +
                ', ' +
                currentBooking.point_origin_delivery.cap +
                ' ' +
                currentBooking.point_origin_delivery.city +
                ' ' +
                currentBooking.point_origin_delivery.province;

              booking_info.destination_point_return =
                currentBooking.point_destination_delivery.address +
                ' ' +
                currentBooking.point_destination_delivery.street_number +
                ', ' +
                currentBooking.point_destination_delivery.cap +
                ' ' +
                currentBooking.point_destination_delivery.city +
                ' ' +
                currentBooking.point_destination_delivery.province;

              currentBooking.driver_delivery != null &&
              currentBooking.driver_delivery.is_alive == false
                ? (booking_info.driver_ritorno =
                    currentBooking.driver_delivery.name +
                    ' ' +
                    currentBooking.driver_delivery.surname)
                : 'Non assegnato';

              currentBooking.driver_delivery != null &&
              currentBooking.driver_delivery.is_alive == false
                ? (booking_info.telephone_return_driver =
                    currentBooking.driver_delivery.telephone_number)
                : null;
            }
          }
        }

        return booking;
      } catch (e) {
        console.error(e);
      }
    };

    loadBooking();

    const showDeleteButton = ref(false);

    // Computed property for formatted date (calendar leaf style)
    const formattedDate = computed(() => {
      if (!booking_info.date) {
        return { day: '--', month: '---', year: '----' };
      }
      const dateParts = booking_info.date.split('/');
      if (dateParts.length === 3) {
        const monthNames = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];
        const monthIndex = parseInt(dateParts[1], 10) - 1;
        return {
          day: dateParts[0],
          month: monthNames[monthIndex] || '---',
          year: '20' + dateParts[2]
        };
      }
      return { day: '--', month: '---', year: '----' };
    });

    const checkBookingDate = (booking_info) => {
      const bookingDate = dayjs(booking_info);
      const todayPlus3Days = dayjs().add(3, 'day');

      if (new Date(bookingDate)  > new Date(todayPlus3Days)) {
        showDeleteButton.value = true;
      }
    };



    const changeCondition = () => {
      condition1 = false;
    };

    const open = async () => {
      ElMessageBox.confirm(
        'Sei sicuro di voler eliminare la prenotazione?',
        'Warning',
        {
          confirmButtonText: 'Elimina',
          cancelButtonText: 'Annulla',
          type: 'warning',
        }
      )
        .then(async () => {
          await bookingAPI.deleteBooking(route.params.id);

          ElMessage({
            type: 'success',
            message: 'Eliminazione completata',
          });
          router.push('/');
        })
        .catch(() => {
        });
    };

    return {
      type,
      tableData,
      bookingId,
      booking_info,
      loadBooking,
      condition1,
      condition2,
      changeCondition,
      activeName,
      open,
      hour_gone,
      hour_return,

      is_gone,
      is_return,
      noteVisibile,

      showDeleteButton,
      router,
      formattedDate
    };
  },

  methods: {
    onSubmit() {
      this.updBooking().then((response) => {
        if (response.status === 200) {
          this.$router.go('/');
          ElMessage({
            message: 'Stato del booking aggiornato!',
            type: 'success',
          });
        }
      });
    },

    deleteTask(id) {

    this.$confirm('Sei sicuro di voler eliminare questa attività?', 'Conferma', {
      confirmButtonText: 'Sì',
      cancelButtonText: 'No',
      type: 'warning',
    }).then(async () => {

      await bookingAPI.deleteTask(id)
      this.$router.go('/');
      this.$message({
        type: 'success',
        message: 'Attività eliminata con successo!',
      });
    }).catch(() => {
      this.$message({
        type: 'info',
        message: 'Eliminazione annullata',
      });
    });
  }
  },
};
</script>

<style scoped>
.details-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

/* Page Header */
.page-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-bottom: 24px;
  border-bottom: 3px solid #4B30F2;
}

/* Calendar Leaf Date Display */
.date-display {
  flex-shrink: 0;
}

.calendar-leaf {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #4B30F2, #3C26C2);
  border-radius: 12px;
  padding: 12px 20px;
  min-width: 90px;
  box-shadow: 0 4px 12px rgba(75, 48, 242, 0.3);
}

.calendar-day {
  font-size: 2.5rem;
  font-weight: 800;
  color: #FFFFFF;
  line-height: 1;
}

.calendar-month {
  font-size: 0.9rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 4px;
}

.calendar-year {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 2px;
}

.header-info {
  flex: 1;
}

.header-info h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #171717;
  margin: 0 0 12px 0;
}

.header-badge {
  display: flex;
  align-items: center;
}

.service-type {
  background: linear-gradient(135deg, #4B30F2, #7562EA);
  color: #FFFFFF;
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Status Alert */
.status-alert {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #FFF7ED, #FFEDD5);
  border-left: 4px solid #F97316;
  border-radius: 8px;
}

.alert-icon {
  font-size: 28px;
  color: #F97316;
}

.alert-icon.pulse {
  animation: pulse 1.5s infinite;
}

.alert-text {
  font-weight: 600;
  color: #9A3412;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Content Grid */
.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

/* Info Cards */
.info-card {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.info-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.info-card.single {
  grid-column: 1 / -1;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: #EFEDF9;
  border-bottom: 1px solid #C0BAEB;
}

.card-icon {
  font-size: 20px;
  color: #4B30F2;
}

.card-header h3 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #171717;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.card-body {
  padding: 20px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #F5F5F5;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row.full-width {
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 0.8rem;
  color: #737373;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.info-value {
  font-size: 0.95rem;
  color: #171717;
  font-weight: 500;
  text-align: right;
}

.info-row.full-width .info-value {
  text-align: left;
}

/* European Style License Plate */
.license-plate {
  display: inline-block;
  background: #FFFFFF;
  border: 2px solid #404040;
  border-radius: 6px;
  padding: 6px 14px;
  font-family: 'Courier New', monospace;
  font-size: 1rem;
  font-weight: 700;
  color: #171717;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Sections */
.section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #171717;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #EFEDF9;
}

.section-title .el-icon {
  color: #4B30F2;
}

/* Route Cards */
.route-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.route-card {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.route-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: #EFEDF9;
}

.route-label {
  font-weight: 600;
  color: #4B30F2;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
}

.km-badge {
  background: #4B30F2;
  color: #FFFFFF;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: 600;
}

.route-content {
  padding: 24px;
}

.location-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 16px;
  background: #FAFAFA;
  border-radius: 10px;
  border-left: 4px solid transparent;
  transition: all 0.2s ease;
}

.location-item:hover {
  background: #F5F5F5;
}

.location-icon {
  flex-shrink: 0;
  font-size: 24px;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.location-icon.start {
  color: #10B981;
  background: #ECFDF5;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.2);
}

.location-icon.end {
  color: #4B30F2;
  background: #EFEDF9;
  box-shadow: 0 2px 6px rgba(75, 48, 242, 0.2);
}

/* Highlight based on location type */
.location-item:has(.location-icon.start) {
  border-left-color: #10B981;
}

.location-item:has(.location-icon.end) {
  border-left-color: #4B30F2;
}

.location-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.location-type {
  font-size: 0.75rem;
  color: #737373;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.location-address {
  font-size: 1rem;
  color: #171717;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
}

.route-arrow {
  display: flex;
  justify-content: center;
  padding: 16px 0;
  color: #A3A3A3;
  font-size: 24px;
}

/* Driver Cards */
.driver-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.driver-card {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.driver-header {
  padding: 14px 20px;
  background: #EFEDF9;
  border-bottom: 1px solid #C0BAEB;
}

.driver-type {
  font-weight: 600;
  color: #4B30F2;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
}

.driver-content {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
}

.driver-avatar {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #4B30F2, #7562EA);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.driver-avatar .el-icon {
  font-size: 24px;
  color: #FFFFFF;
}

.driver-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.driver-name {
  font-size: 1rem;
  font-weight: 600;
  color: #171717;
}

.driver-phone {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  color: #737373;
}

.driver-phone .el-icon {
  font-size: 14px;
  color: #4B30F2;
}

/* Car Description & Notes */
.car-description,
.notes-text {
  font-size: 0.95rem;
  color: #404040;
  line-height: 1.6;
  margin: 0;
}

/* Tasks Section */
.tasks-container {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.tasks-collapse :deep(.el-collapse-item__header) {
  padding: 16px 20px;
  background: #EFEDF9;
  font-weight: 600;
}

.collapse-header {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.tasks-list {
  padding: 0 20px;
}

.task-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #F5F5F5;
}

.task-item:last-child {
  border-bottom: none;
}

.task-content {
  flex: 1;
  margin-right: 16px;
}

.task-description {
  font-size: 0.95rem;
  color: #171717;
  margin-bottom: 8px;
}

.task-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.task-cost {
  font-weight: 700;
  color: #4B30F2;
  font-size: 1rem;
}

.tasks-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #FAFAFA;
  border-top: 2px solid #EFEDF9;
  font-weight: 600;
}

.total-amount {
  font-size: 1.25rem;
  color: #4B30F2;
}

/* Actions Section */
.actions-section {
  display: flex;
  justify-content: center;
  padding: 32px 0;
}

/* Responsive */
@media (max-width: 768px) {
  .details-page {
    padding: 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .header-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .calendar-leaf {
    min-width: 100px;
    padding: 14px 24px;
  }

  .calendar-day {
    font-size: 3rem;
  }

  .content-grid {
    grid-template-columns: 1fr;
  }

  .route-cards {
    grid-template-columns: 1fr;
  }

  .driver-cards {
    grid-template-columns: 1fr;
  }

  .location-item {
    padding: 14px;
  }

  .task-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .task-content {
    margin-right: 0;
    width: 100%;
  }
}
</style>
